import React from 'react';
import { Navigate } from 'react-router-dom';

import { PATH_ACCESS_FORBIDDEN } from './routes';
import { useAuth } from '../app/AuthorizationProvider';
import { Values } from '../components/configuration/types';
import { ETL_PERMISSIONS } from '../utils/keycloakUtils';

export interface ProtectedRouteProps {
  permissions?: Values<typeof ETL_PERMISSIONS>[];
  requireAllPermissions?: boolean;
  customPermissionCheck?: () => boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps & React.ComponentProps<any>> = ({
  permissions,
  requireAllPermissions = true,
  customPermissionCheck,
  children,
}) => {
  if (!permissions && !customPermissionCheck)
    throw new Error('ProtectedRoute used without permissions or customPermissionCheck!');

  const { userHasPermissions } = useAuth();

  const userHasRequiredPermissions = customPermissionCheck
    ? customPermissionCheck()
    : userHasPermissions(permissions, requireAllPermissions);

  if (!userHasRequiredPermissions) {
    return <Navigate to={`${PATH_ACCESS_FORBIDDEN}`} replace />;
  }

  return children;
};
